import type { DealerDiscount } from './discountTypes';

export type ValidationResult = {
    isValid: boolean;
    error?: string;
};

export const validateDiscountName = ({
    name,
    allDiscounts,
    currentDiscountId
}: {
    name: string;
    allDiscounts: DealerDiscount[];
    currentDiscountId: string;
}): ValidationResult => {
    const trimmedName = name.trim();

    // Check if name is empty and amount has value - "Select a name" error
    if (!trimmedName) {
        return { isValid: false, error: 'Select a name' };
    }

    // Check name length (3-40 characters) - "Name must be between 3-40 characters"
    if (trimmedName.length < 3 || trimmedName.length > 40) {
        return { isValid: false, error: 'Name must be between 3-40 characters' };
    }

    // Check for duplicates (case-insensitive) - "Duplicate Name"
    const isDuplicate = allDiscounts.some(
        (discount) =>
            discount.id !== currentDiscountId &&
            discount.discountName.toLowerCase() === trimmedName.toLowerCase() &&
            discount.discountName.trim() !== ''
    );

    if (isDuplicate) {
        return { isValid: false, error: 'Duplicate Name' };
    }

    // Name allows special characters - no restriction needed, validation passes
    return { isValid: true };
};

export const validateDiscountAmount = (amount: string): ValidationResult => {
    if (!amount) {
        return { isValid: false, error: 'Amount is required' };
    }

    return { isValid: true };
};

export const hasValidationErrors = (discounts: DealerDiscount[]): boolean => {
    return discounts.some(
        (discount) => !!discount.nameError || !!discount.amountError || !discount.discountAmount || !discount.discountName
    );
};
